const activateAnimations = () => {
  document.querySelectorAll('.anm-move-up:not(.active-anm-heading)').forEach((el) => {
    el.classList.add('active-anm-heading');
  });

  document.querySelectorAll('.anm-fade-element:not(.is-visible)').forEach((el) => {
    el.classList.add('is-visible');
  });

  document.querySelectorAll('.animate_transition_slide__image:not(.active)').forEach((el) => {
    el.classList.add('active');
  });

  document.querySelectorAll('.animate_transition_card__image:not(.active)').forEach((el) => {
    el.classList.add('active', 'lazy_active');
  });

  document.querySelectorAll('.x-slide-animation').forEach((el) => {
    const container = el.parentElement;
    if (container && !container.classList.contains('is-ready-to-animate')) {
      container.classList.add('is-ready-to-animate');
    }
  });

  document.querySelectorAll('.splider-testimonial, .x-splide').forEach((el) => {
    el.classList.add('is-ready-to-animate');
  });

  document.querySelectorAll('.promotion').forEach((el) => {
    el.classList.remove('bg-[#c9c9c9]');
  });
};

const uncloakStuckElements = () => {
  document.querySelectorAll('[x-cloak]').forEach((el) => {
    el.removeAttribute('x-cloak');
  });
};

const reinitAlpineComponents = () => {
  if (!window.Alpine) return;

  document.querySelectorAll('[x-data]').forEach((el) => {
    if (!el._x_dataStack?.length) {
      try {
        Alpine.initTree(el);
      } catch (e) {
        console.error('[alpine-reinit] initTree', e);
      }
    }
  });
};

const initVideoLoopingSections = () => {
  document.querySelectorAll('[id^="video-looping-"]').forEach((el) => {
    const component = el._x_dataStack?.[0];
    if (component?.initVideoLooping && !el.dataset.loopingReady) {
      try {
        component.initVideoLooping();
        el.dataset.loopingReady = 'true';
      } catch (e) {
        console.error('[alpine-reinit] video-looping', e);
      }
    }
  });
};

const refreshSplideSections = () => {
  if (!window.Alpine?.store('xSplide')) return;

  document.querySelectorAll('.x-splide.splide').forEach((el) => {
    if (el.splide || el.classList.contains('is-initialized') || el.classList.contains('splide--initialized')) return;

    try {
      if (!el._x_dataStack?.length && window.Alpine?.initTree) {
        Alpine.initTree(el);
      }
    } catch (e) {
      console.error('[alpine-reinit] splide', e);
    }
  });
};

const revealShopTheLookHotspots = () => {
  document.querySelectorAll('.x-hotspot.opacity-0').forEach((el) => {
    el.classList.add('opacity-100');
  });

  if (window.ShopTheLookAllPanel?.initAll) {
    window.ShopTheLookAllPanel.initAll();
  }
};

const bootstrapFeaturedCollectionTabs = () => {
  document.querySelectorAll('.featured-collection[x-data*="xFeaturedCollection"]').forEach((section) => {
    const comp = section._x_dataStack?.[0];
    if (!comp) return;

    const syncTabs = () => {
      const activeIndex = comp.currentTab || 1;
      section.querySelectorAll('[id^="x-fc-"]').forEach((tab) => {
        const match = tab.id.match(/-(\d+)$/);
        const tabIndex = match ? Number(match[1]) : 0;
        const isActive = tabIndex === activeIndex;

        if (isActive) {
          tab.style.removeProperty('display');
          tab.classList.add('is-active-tab');
        } else {
          tab.style.setProperty('display', 'none', 'important');
          tab.classList.remove('is-active-tab');
        }
      });

      section.querySelectorAll('.collection-title [class*="label-"]').forEach((label, i) => {
        if ((i + 1) === activeIndex) {
          label.classList.add('active');
        } else {
          label.classList.remove('active');
        }
      });
    };

    if (!section.dataset.tabsSynced) {
      section.dataset.tabsSynced = 'true';
      section.addEventListener('click', () => {
        requestAnimationFrame(syncTabs);
      });
    }

    section.querySelectorAll('[id^="x-fc-"]').forEach((tab) => {
      if (!tab._x_dataStack?.length && window.Alpine?.initTree) {
        try {
          Alpine.initTree(tab);
        } catch (e) {
          console.error('[alpine-reinit] featured-collection tab', e);
        }
      }
    });

    syncTabs();
  });
};

const bootstrapHighlightAnimations = () => {
  document.querySelectorAll('[id*="highlight_text_with_image"] .x-container-content').forEach((root) => {
    const comp = root._x_dataStack?.[0];
    if (!comp?.startAnim) return;

    const heading = root.querySelector('[class^="heading--"]');
    if (!heading || heading.dataset.highlightReady === 'true') return;

    try {
      if (!heading.querySelector('.text-highlight') && typeof comp.load === 'function') {
        comp.load(heading, false, false);
      }
      if (!comp.observer) {
        comp.startAnim(heading, false, false, 0);
      }
      heading.dataset.highlightReady = 'true';
    } catch (e) {
      console.error('[alpine-reinit] highlight animation', e);
    }
  });
};

const bootstrapTestimonialSplides = () => {
  const store = Alpine?.store('xSplide');
  if (!store || typeof Splide === 'undefined') return;

  document.querySelectorAll('.splider-testimonial.x-splide').forEach((el) => {
    if (el.splide || el.classList.contains('splide--initialized')) return;

    const isGoogle = !!el.closest('.testimonials-layout-google');
    try {
      store.load(el, {
        updateOnMove: true,
        mediaQuery: 'min',
        gap: isGoogle ? 8 : 10,
        focus: isGoogle ? 'center' : undefined,
        trimSpace: isGoogle ? false : undefined,
        type: 'loop',
        pauseOnFocus: false,
        breakpoints: {
          768: {
            gap: isGoogle ? 8 : 0,
            perPage: 1,
            perMove: 1,
            focus: isGoogle ? 'center' : undefined,
            padding: isGoogle ? { left: '8%', right: '8%' } : undefined,
          },
          1024: {
            destroy: false,
            gap: isGoogle ? 12 : undefined,
            perPage: isGoogle ? 3 : 2,
            perMove: 1,
            focus: isGoogle ? 'center' : undefined,
            speed: isGoogle ? 600 : 800,
            padding: isGoogle ? { left: '2%', right: '2%' } : undefined,
          },
        },
        classes: {
          arrows: 'splide__arrows block',
          pagination: 'hidden',
        },
      });
    } catch (e) {
      console.error('[alpine-reinit] testimonial splide', e);
    }
  });
};

const runRecovery = () => {
  if (!window.Alpine) return;
  reinitAlpineComponents();
  initVideoLoopingSections();
  refreshSplideSections();
  bootstrapTestimonialSplides();
  bootstrapFeaturedCollectionTabs();
  bootstrapHighlightAnimations();
  revealShopTheLookHotspots();
  activateAnimations();
  uncloakStuckElements();
};

document.addEventListener('alpine:initialized', () => {
  requestAnimationFrame(runRecovery);
});

document.addEventListener('DOMContentLoaded', () => {
  requestAnimationFrame(() => {
    requestAnimationFrame(runRecovery);
  });
});

window.addEventListener('load', () => {
  setTimeout(runRecovery, 100);
});
